module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "station-boxs"
  }, [_c('div', {
    staticClass: "cont-top com-model flex flex-column align-initial flex-between"
  }, [_c('div', {
    staticClass: "cont-title flex c-c-c"
  }, [_vm._v("岗位管理\n            "), _c('div', {
    staticClass: "router-contaier flex"
  }, [_c('router-link', {
    staticClass: "flex c-btn m-l-24",
    attrs: {
      "to": "/index/posts/release"
    }
  }, [_vm._v("\n                    发布岗位\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "to-batch-release-ai flex",
    on: {
      "click": _vm.openBatchAiDialog
    }
  }, [_c('font', [_vm._v("AI")]), _vm._v("Ai帮你批量发岗位\n                ")], 1)], 1)]), _vm._v(" "), _c('el-tabs', {
    staticClass: "ac-tabs",
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.tabindex),
      callback: function($$v) {
        _vm.tabindex = $$v
      },
      expression: "tabindex"
    }
  }, [_vm._l((_vm.tabList), function(item, index) {
    return [(index != 1) ? _c('el-tab-pane', {
      key: index,
      attrs: {
        "index": index,
        "label": item,
        "name": index.toString()
      }
    }) : _vm._e()]
  })], 2)], 1), _vm._v(" "), (_vm.checkList && _vm.checkList.length) ? [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.rowList.length),
      expression: "rowList.length"
    }],
    staticClass: "checked-all-box"
  }, [_c('el-checkbox', {
    attrs: {
      "indeterminate": _vm.isIndeterminate
    },
    on: {
      "change": _vm.handleCheckAllChange
    },
    model: {
      value: (_vm.checkAll),
      callback: function($$v) {
        _vm.checkAll = $$v
      },
      expression: "checkAll"
    }
  }, [_vm._v("全选")]), _vm._v(" "), _vm._l((_vm.checkList), function(btn) {
    return _c('el-button', {
      key: btn,
      attrs: {
        "type": "primary",
        "plain": "",
        "disabled": !_vm.checkedIdList.length
      },
      on: {
        "click": function($event) {
          _vm.handleBatch(btn)
        }
      }
    }, [_vm._v(_vm._s(btn))])
  })], 2)] : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "4px"
    }
  }, [_c('div', {
    staticClass: "stationbox com-model",
    staticStyle: {
      "padding": "28px 0"
    }
  }, [(_vm.pageTotal) ? [_c('el-checkbox-group', {
    class: {
      'c-el-checkbox': true, 'no-checkbox': !_vm.checkList || !_vm.checkList.length
    },
    on: {
      "change": _vm.handleCheckedidList
    },
    model: {
      value: (_vm.checkedIdList),
      callback: function($$v) {
        _vm.checkedIdList = $$v
      },
      expression: "checkedIdList"
    }
  }, _vm._l((_vm.rowList), function(item) {
    return _c('el-checkbox', {
      key: item.id,
      attrs: {
        "label": item.id
      }
    }, [_c('div', {
      staticClass: "stationbox-item clearfix"
    }, [_c('div', {
      staticClass: "stationbox-item-top clearfix"
    }, [_c('div', {
      staticClass: "title-info"
    }, [_c('div', {
      staticClass: "stat-tit"
    }, [_c('span', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "value qr-img",
      on: {
        "click": function($event) {
          _vm.getWechatCode(item.id)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("../../assets/images/icon_code.png")
      }
    })]), _vm._v(" "), (item.videoUrl) ? _c('img', {
      staticClass: "icon-img",
      attrs: {
        "src": require("../../assets/images/icon_movie.png")
      },
      on: {
        "click": function($event) {
          _vm.handlePreview(item.videoUrl)
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "right"
    }, [_c('div', {
      staticClass: "r-item"
    }, [_vm._v("查看岗位"), _c('span', [_vm._v(_vm._s(item.viewsCount))]), _vm._v("次")]), _vm._v(" "), _c('div', {
      staticClass: "r-item"
    }, [_vm._v("获取电话"), _c('span', [_vm._v(_vm._s(item.getPhoneCount))]), _vm._v("次")]), _vm._v(" "), _c('div', {
      staticClass: "r-item"
    }, [_vm._v("简历收到"), _c('span', [_vm._v(_vm._s(item.deliverCount))]), _vm._v("份")])])]), _vm._v(" "), _c('div', {
      staticClass: "stat-treat-money"
    }, [_vm._v("￥" + _vm._s(item.minSalary) + " - " + _vm._s(item.maxSalary))]), _vm._v(" "), _c('dl', {
      staticClass: "stat-dl-require flex"
    }, [_c('dd', [_c('span', {
      staticClass: "stat-dl-retit"
    }, [_vm._v("性别要求：")]), _vm._v(" "), _c('span', {
      staticClass: "stat-dl-rename"
    }, [_vm._v(_vm._s(_vm._f("sexsel")(item.requireSex)))])]), _vm._v(" "), _c('dd', [_c('span', {
      staticClass: "stat-dl-retit"
    }, [_vm._v("年龄要求：")]), _vm._v(" "), _c('span', {
      staticClass: "stat-dl-rename"
    }, [_vm._v(_vm._s(item.requireMinage) + "-" + _vm._s(item.requireMaxage) + "岁")])]), _vm._v(" "), _c('dd', [_c('span', {
      staticClass: "stat-dl-retit"
    }, [_vm._v("学历要求：")]), _vm._v(" "), _c('span', {
      staticClass: "stat-dl-rename"
    }, [_vm._v(_vm._s(_vm._f("edusel")(item.requireEdu, _vm.eduList)))])]), _vm._v(" "), _c('dd', [_c('span', {
      staticClass: "stat-dl-retit"
    }, [_vm._v("经验要求：")]), _vm._v(" "), _c('span', {
      staticClass: "stat-dl-rename"
    }, [_vm._v(_vm._s(_vm._f("expsel")(item.requireExp, _vm.expList)))])])])]), _vm._v(" "), _c('div', {
      staticClass: "stat-list flex"
    }, [(item.provideCarsubsidy) ? _c('div', {
      staticClass: "stat-item"
    }, [_c('span', [_vm._v("车")]), _vm._v("车补" + _vm._s(item.carsubsidy) + "元/人")]) : _vm._e(), _vm._v(" "), (item.rewardStatus === 1) ? _c('div', {
      staticClass: "stat-item",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.handleOpera(item)
        }
      }
    }, [_vm._v("悬赏转发")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "stationbox-item-bottom flex flex-between"
    }, [_c('div', {
      staticClass: "stat-release flex flex-between"
    }, [_c('div', {
      staticClass: "flex"
    }, [_c('p', [_vm._v("发布者：")]), _vm._v(" "), _c('div', {
      staticClass: "stat-img"
    }, [_c('img', {
      attrs: {
        "src": item.hrHeadImage ? item.hrHeadImage : '//oss.51ztx.com/face.png'
      }
    })]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.hrName))])])]), _vm._v(" "), (item.createAt) ? _c('p', {
      staticClass: "time"
    }, [_vm._v("创建时间" + _vm._s(item.createAt.slice(0, -2)))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "stat-btn-group"
    }, [(_vm.tabindex == 0) ? _c('div', {
      staticClass: "stat-btn-group-main"
    }, [_c('div', {
      staticClass: "stat-btn primary-border-btn",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.handleOpera(item)
        }
      }
    }, [_vm._v("悬赏转发")]), _vm._v(" "), _c('div', {
      staticClass: "stat-btn error-border-btn",
      on: {
        "click": function($event) {
          _vm.postOffline(item.id)
        }
      }
    }, [_vm._v("下线")]), _vm._v(" "), _c('div', {
      staticClass: "stat-btn primary-border-btn",
      on: {
        "click": function($event) {
          _vm.edit(item.id)
        }
      }
    }, [_vm._v("编辑岗位")]), _vm._v(" "), _c('div', {
      staticClass: "stat-btn warning-border-btn",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.refresh(item.id)
        }
      }
    }, [_vm._v("岗位刷新")])]) : _vm._e(), _vm._v(" "), (_vm.tabindex == 1) ? _c('div', {
      staticClass: "stat-btn-group-main"
    }, [_c('div', {
      staticClass: "stat-btn primary-border-btn",
      on: {
        "click": function($event) {
          _vm.republish(item.id)
        }
      }
    }, [_vm._v("重新上线")])]) : _vm._e(), _vm._v(" "), (_vm.tabindex == 2) ? _c('div', {
      staticClass: "stat-btn-group-main"
    }, [_c('div', {
      staticClass: "stat-btn error-border-btn",
      on: {
        "click": function($event) {
          _vm.postDelete(item.id)
        }
      }
    }, [_vm._v("删除")]), _vm._v(" "), _c('div', {
      staticClass: "stat-btn primary-border-btn",
      on: {
        "click": function($event) {
          _vm.edit(item.id)
        }
      }
    }, [_vm._v("编辑岗位")])]) : _vm._e(), _vm._v(" "), (_vm.tabindex == 3) ? _c('div', {
      staticClass: "stat-btn-group-main"
    }, [_c('div', {
      staticClass: "stat-btn error-border-btn",
      on: {
        "click": function($event) {
          _vm.postDelete(item.id, true)
        }
      }
    }, [_vm._v("删除")]), _vm._v(" "), _c('div', {
      staticClass: "stat-btn primary-border-btn",
      on: {
        "click": function($event) {
          _vm.republish(item.id)
        }
      }
    }, [_vm._v("重新上线")])]) : _vm._e(), _vm._v(" "), (_vm.tabindex == 4) ? _c('div', {
      staticClass: "stat-btn-group-main"
    }, [(item.status * 1 === 0) ? _c('div', [_c('div', {
      staticClass: "stat-btn error-border-btn",
      on: {
        "click": function($event) {
          _vm.cancelAudit(item.id)
        }
      }
    }, [_vm._v("取消审核")]), _vm._v(" "), _c('div', {
      staticClass: "stat-btn gray-border-btn",
      staticStyle: {
        "cursor": "text"
      }
    }, [_vm._v("审核中")])]) : _c('div', [(item.status * 1 === -1) ? _c('p', {
      staticClass: "stat-examine-lose"
    }, [_vm._v("\n                                                审核失败，" + _vm._s(item.auditRemark))]) : _vm._e(), _vm._v(" "), (item.status * 1 === 1) ? _c('p', {
      staticClass: "stat-examine-suc flex"
    }, [_c('i', {
      staticClass: "el-icon-check"
    }), _vm._v("\n                                                审核成功，请随时留意线上岗位状态")]) : _vm._e()])]) : _vm._e()])])])])
  })), _vm._v(" "), _c('div'), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.pageNum,
      "page-sizes": [10, 20, 30, 40],
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.pageTotal
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })] : [_c('no-data')]], 2)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "视频预览",
      "visible": _vm.videoVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.videoVisible = $event
      }
    }
  }, [(_vm.videoUrl && _vm.videoVisible) ? _c('video', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "controls": "",
      "loop": "",
      "src": _vm.videoUrl,
      "autoplay": ""
    }
  }) : _vm._e()]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "size": "tiny"
    },
    model: {
      value: (_vm.imageVisible),
      callback: function($$v) {
        _vm.imageVisible = $$v
      },
      expression: "imageVisible"
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.imageUrl,
      "alt": ""
    }
  })]), _vm._v(" "), _c('DialogUpload', {
    attrs: {
      "show": _vm.visiableUpload
    },
    on: {
      "update:show": function($event) {
        _vm.visiableUpload = $event
      }
    }
  }), _vm._v(" "), _c('Config', {
    attrs: {
      "show": _vm.configVisible,
      "id": _vm.rewardInfo.id
    },
    on: {
      "update:show": function($event) {
        _vm.configVisible = $event
      },
      "refresh": _vm.handleRefresh
    }
  }), _vm._v(" "), _c('RForm', _vm._b({
    attrs: {
      "show": _vm.formVisible,
      "type": "rewordType"
    },
    on: {
      "update:show": function($event) {
        _vm.formVisible = $event
      },
      "refresh": _vm.handleRefresh,
      "history": _vm.handleToHistory,
      "toConfig": _vm.handleToConfig
    }
  }, 'RForm', _vm.rewardInfo, false)), _vm._v(" "), _c('HistoryDetail', _vm._b({
    attrs: {
      "show": _vm.historyDetailVisible
    },
    on: {
      "update:show": function($event) {
        _vm.historyDetailVisible = $event
      }
    }
  }, 'HistoryDetail', _vm.rewardInfo, false))], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-688f2ab5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/posts/list.vue
// module id = 886
// module chunks = 1